import React from "react";

import 'url-search-params-polyfill';

import Checkbox from "../Checkbox";
import Radio from "../Radio";

export default class EmbedBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: "multiple_choice",
      results: true,
    };
  }

  onTextInputClick() {
    this.textInput.select();
    try {
      if(document.execCommand('copy')) {
        clearTimeout(this.copyTimeout);
        this.setState({ copied: true }, () => (this.copyTimeout = setTimeout(() => this.setState({ copied: false }), 3000)));
      }
    } catch(e) {
    }
  }

  getUrl() {
    const searchParams = new URLSearchParams();
    searchParams.append("mode", this.state.mode);
    searchParams.append("results", this.state.results);
    return this.props.url + "?" + searchParams.toString();
  }

  getCode() {
    return "<iframe style=\"border: 2px solid #000;\" src=\"" + this.getUrl() + "\" width=\"100%\" height=\"640\"></iframe>";
  }

  render() {
    return (
      <div>
        <p>You can embed the code below into your website or blog just like you would with a Youtube video. Your students will then be able to play through all the sentences in the collection on your website or blog in a single round without having to sign in.</p>
        <div className="form-group">
          <strong>Mode:</strong>
          <div style={{ marginLeft: 15 }}>
            <Radio
              checked={this.state.mode === "multiple_choice"}
              label="Multiple Choice"
              name="mode"
              onChange={(e) => this.setState({ mode: e.target.value })}
              value="multiple_choice"
            />
            <Radio
              checked={this.state.mode === "text_input"}
              label="Text Input"
              name="mode"
              onChange={(e) => this.setState({ mode: e.target.value })}
              value="text_input"
            />
          </div>
        </div>
        <div className="form-group">
          <Checkbox
            checked={this.state.results}
            label="Allow players to submit their results at the end of the round"
            name="results"
            onChange={(e) => this.setState({ results: e.target.checked })}
          />
        </div>
        <textarea
          className="form-control"
          onClick={() => this.onTextInputClick()}
          readOnly
          ref={(el) => this.textInput = el}
          value={this.getCode()}
        />
        {this.state.copied && <div>Copied!</div>}
      </div>
    );
  }
}

